/* eslint-disable array-element-newline, react/jsx-no-bind */
import { useEffect, useState } from "react";
import { UserAddIcon } from "@heroicons/react/outline";
import { format } from "date-fns";
import { useQuery } from "react-query";

import CourseCard from "../components/CourseCard";
import CourseSearchFilter from "../components/CourseSearchFilter";
import Loader from "../../../components/Loader";
import PaginationWithPage from "../../../components/PaginationWithPager";
import TabHeader from "../components/TabHeader";
import courseData from "../../../tempData/myCourses.json";
import { getSimplifiedCourseData } from "../helpers/helpers";
import myCoursesQuery from "../services/myCoursesQuery";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

const courses = getSimplifiedCourseData(courseData);
const futureCourses = courses.filter((course) => course.rawDate > new Date());

const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
const after = format(yesterday, "yyyy-MM-dd HH:mm:ss");

const MyAccountMyCourses = () => {

	const { user } = useAuth();
	const { addNotification } = useNotifications();
	const [currentCourses, setCurrentCourses] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [page, setPage] = useState(1);

	const {
		isLoading,
		data: myCourses
	// eslint-disable-next-line object-property-newline
	} = myCoursesQuery(
		useQuery,
		{
			after,
			attendee: [String(user.attendeeId)],
			page
		}, {
			onError: (error) => {
				addNotification({
					message: error.message || "Error fetching your registrations",
					type: "danger"
				});
			}
		},
		"myCourses"
	);
	useEffect(() => {
		if (myCourses) {
			setCurrentCourses(myCourses.registrations);
		}
	}, [myCourses]);

	const handleSearch = () => {
		const newSearchResults = futureCourses.filter((course) => {
			let match = false;

			/* eslint-disable curly */
			if (course.title.toLowerCase().includes(searchValue.toLowerCase())) match = true;
			if (course.description.toLowerCase().includes(searchValue.toLowerCase())) match = true;
			return match;
		});
		setCurrentCourses(newSearchResults);
	};

	return (
		<>
			<TabHeader
				description="These are the upcoming classes you are registered for."
				title="My Classes"
			/>

			{/* eslint-disable-next-line no-constant-condition */}
			{false ? (
				<CourseSearchFilter
					handleSearch={handleSearch}
					searchValue={searchValue}
					setSearchValue={setSearchValue}
				/>) : null}

			{myCourses?.pager && myCourses.pager.total_pages > 1
				? (
					<div className="d-flex justify-content-between">
						<PaginationWithPage onChange={setPage} pager={myCourses.pager} />
						<div>Page {page} of {myCourses.pager.total_pages}</div>
					</div>) : null}

			{
				isLoading
					? <Loader height="200px" width="100%" />
					: currentCourses.map((registration) => (
						<CourseCard
							course={registration.course}
							key={registration.id}
							otherContent={registration?.guest
								? <div className="mb-2"><UserAddIcon className="i" /> GUEST: {registration.guest.name}</div> : null}
							registrationType={registration.registrationType || "In Person"}
						/>))
			}
		</>
	);

};

export default MyAccountMyCourses;
